<template>
  <div v-if="current">
    <div class="row" v-if="dio">
      <div class="col-md-3"><v-text-field label="Código" v-model="dio.codigo" outlined dense disabled></v-text-field></div>
      <div class="col-md-6"><v-text-field label="Nome" v-model="dio.nome" outlined dense disabled></v-text-field></div>
      <div class="col-md-3"><v-text-field label="Portas" v-model="dio.portas" outlined dense disabled></v-text-field></div>
    </div>
    <v-simple-table>
      <thead>
        <tr>
          <th>Número</th>
          <th>Descrição</th>
          <th>Comentário</th>
          <th>Sinal</th>
          <th>Ações</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="item in current" :key="item.id">
          <td>{{ item.numero }}</td>
          <td>{{ item.descricao }}</td>
          <td>{{ item.comentario }}</td>
          <td>{{ item.sinal }}</td>
          <td>
            <v-btn small color="primary" @click="view(item.id)" v-if="$auth.check('INFRA_DIO_WRITE')">detalhes</v-btn>
          </td>
        </tr>
      </tbody>
    </v-simple-table>
  </div>
</template>

<script>
import api from "../../api/index.js";
import router from "../../router/index.js";
export default {
  data: () => ({
    current: null,
    dio: null
  }),
  created: function() {
    this.list();
    this.loadDio();
  },
  methods: {
    loadDio: function(){
      var me = this;
      var token = localStorage.getItem("token");
      api
        .get("/dio/"+ this.$route.params.id, { headers: { Authorization: "Bearer " + token } })
        .then(function(response) {
          me.dio = response.data;
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    list: function() {
      var me = this;
      var token = localStorage.getItem("token");
      api
        .get("/dio_porta/dio/"+ this.$route.params.id, { headers: { Authorization: "Bearer " + token } })
        .then(function(response) {
          me.current = response.data;
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    view: function(id) {
      router.push({ path: `/dio_porta/${id}` });
    }
  }
};
</script>